import React, { useState, useEffect, useCallback } from 'react';
import { months } from '@utils';
import { useSelector } from 'react-redux';
import {
  ComboBox,
  Button,
  WideAlert,
  LoadingIndicator,
  Icons,
} from '@components';
import { TransparenciaService } from '@services/transparencia';
import { getMonth, getYear } from 'date-fns';
import { mdiCommentAlertOutline } from '@mdi/js';

export const Documentos = ({ idDocumento, texto }) => {
  const dataAtual = new Date();
  const [caminhoArquivo, setCaminhoArquivo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pesquisa, setPesquisa] = useState(false);
  const custom = useSelector((state) => state.customizaSistema);
  const plano = useSelector((state) => state.user.plano);
  const [anoSelecioando, setAnoSelecionado] = useState(
    getYear(dataAtual).toString()
  );
  const [mesSelecionado, setMesSelecionado] = useState(
    months
      .filter((item) => parseInt(item.numero, 10) === getMonth(dataAtual) + 1)
      .map((result) => result)[0]
      .numero.toString()
  );
  const [habilitarPDF, setHabilitarPDF] = useState(false);
  const [habilitarSelecaoMeses, setHabilitarSelecaoMeses] = useState(false);
  const [opcoesMeses, setOpcoesMeses] = useState(
    months.sort((a, b) => {
      return b.numero.localeCompare(a.numero);
    })
  );
  const opcoesAnos = () => {
    const anos = [];
    for (let i = 2008; i < getYear(dataAtual) + 1; i += 1) {
      anos.push(i.toString());
    }
    return anos.sort((a, b) => {
      return b.localeCompare(a);
    });
  };
  const getLinkDocumento = useCallback(async () => {
    setLoading(true);
    const transparenciaService = new TransparenciaService();
    const documento = await transparenciaService.getDocumentosTransparencia(
      idDocumento,
      anoSelecioando,
      mesSelecionado,
      plano
    );
    const arquivosResultantes = documento.map((item) => {
      return {
        nome: item.Title,
        url: item.URL,
        ano: item.Ano,
        mes: item.Mes,
      };
    });
    setPesquisa(true);
    setCaminhoArquivo(arquivosResultantes);
    setLoading(false);
  }, [anoSelecioando, mesSelecionado, idDocumento]);

  useEffect(() => {
    getLinkDocumento();
  }, [getLinkDocumento]);

  useEffect(() => {
    if (anoSelecioando !== '') {
      setHabilitarPDF(true);
    }
    if (anoSelecioando !== undefined) setHabilitarSelecaoMeses(true);
    if (anoSelecioando === getYear(new Date()).toString()) {
      const opcoesFiltro = [];
      opcoesFiltro.push({ numero: '', nome: 'Todos os meses' });
      months.forEach((item) => {
        if (parseInt(item.numero, 10) - 1 <= getMonth(new Date())) {
          opcoesFiltro.push(item);
        }
      });
      opcoesFiltro.sort((a, b) => {
        return b.numero.toString().localeCompare(a.numero.toString());
      });
      setOpcoesMeses(opcoesFiltro);
    } else {
      const opcoesFiltro = [];
      opcoesFiltro.push({ numero: '', nome: 'Todos os meses' });
      months.forEach((item) => {
        opcoesFiltro.push(item);
      });
      setOpcoesMeses(opcoesFiltro);
    }
  }, [mesSelecionado, anoSelecioando, idDocumento]);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <p className="ts-20 fw-bold my-3">{texto}</p>
          <p className="ts-20 fw-bold">Escolha o período</p>
          <div className="row col-12 col-md-8 col-lg-6 mb-4 mt-2">
            <ComboBox
              color={custom.nomeCorPrincipal}
              label="Ano"
              className="mt-3 col-12 col-md4 col-lg-4"
              value={anoSelecioando}
              onChange={setAnoSelecionado}
              tooltip="Selecione o ano de referência"
              options={opcoesAnos().map((x) => {
                return { value: x, label: x };
              })}
            />
            <ComboBox
              isDisabled={!habilitarSelecaoMeses}
              color={custom.nomeCorPrincipal}
              label="Mês"
              className="mt-3 col-12 col-md6 col-lg-6"
              value={mesSelecionado}
              onChange={setMesSelecionado}
              tooltip="Escolha o mês de referência"
              options={opcoesMeses.map((s) => {
                return {
                  value: s.numero,
                  label: s.nome,
                };
              })}
            />
            <div className="row col-6 align-items-center mt-32">
              <Button
                disabled={!habilitarPDF}
                className="ms-lg-2"
                icon="search"
                onClick={getLinkDocumento}
              >
                Pesquisar
              </Button>
            </div>
          </div>
        </div>
      </div>
      {!loading && pesquisa && (
        <div className="row mt-32">
          <p className="ts-20 fw-bold mb-2">Documentos</p>
          {caminhoArquivo.length > 0 &&
            caminhoArquivo.map((item) => {
              return (
                <div className="col-12 col-lg-6 col-xl-4 mb-4" key={item.nome}>
                  <div className="card h-100">
                    <div className="card-body">
                      <h3 className="fw-bold ts-18">{item.nome}</h3>
                      <h5 className="ts-16 mt-2">{`${item.mes}/${item.ano}`}</h5>
                    </div>
                    <div className="card-footer">
                      <hr />
                      <a
                        href={`https://participante.forluz.org.br/${item.url}`}
                        rel="noreferrer"
                        target="_blank"
                        download
                        title="Abrir documento"
                        className="d-md-flex ts-14 mb-2 mt-4 aButton"
                      >
                        Baixar documento
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          {caminhoArquivo.length === 0 && (
            <div className="col-12">
              <div className="card h-100">
                <div className="card-body">
                  <WideAlert className="mb-4" iconClear={false}>
                    <div className="d-block d-lg-flex align-items-center">
                      <Icons
                        path={mdiCommentAlertOutline}
                        color="var(--primary-color)"
                        size={2}
                        style={{ marginRight: 4 }}
                      />
                      <p className="ts-16">
                        <strong>
                          Não foram encontrados documentos para o filtro
                          selecionado
                        </strong>
                      </p>
                    </div>
                  </WideAlert>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {loading && <LoadingIndicator />}
    </>
  );
};
